<template>
  <b-card
    no-body
    class="coverage-area-page p-2 p-md-3 bg-white"
  >
    <!-- Header Title -->
    <div class="d-flex align-items-center pb-2 mb-3 border-bottom-subtle">
      <h3 class="page-title m-0">
        Coverage Area
      </h3>
    </div>

    <!-- Navigation Tabs -->
    <div class="mb-2">
      <div class="tab-container">
        <button
          type="button"
          class="tab-btn"
          :class="{ active: activeTab === 'komship' }"
          @click="activeTab = 'komship'"
        >
          Komship
        </button>
        <button
          type="button"
          class="tab-btn"
          :class="{ active: activeTab === 'rajaongkir' }"
          @click="activeTab = 'rajaongkir'"
        >
          RajaOngkir
        </button>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="d-flex justify-content-end align-items-center mb-1">
      <div
        class="d-flex h-10"
        style="gap: 12px;"
      >
        <b-button
          class="btn-ubah-coverage d-flex align-items-center"
          @click="$router.push(`/coverage-area/pengajuan/${activeTab}`)"
        >
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/git-compare.svg"
            alt="coverage"
            width="12"
            height="12"
            class="mr-1"
          >
          <span>Ubah Coverage Area</span>
        </b-button>
        <b-button
          class="btn-data-acuan d-flex align-items-center"
          @click="$router.push(`/coverage-area/acuan?product=${activeTab}`)"
        >
          <span>Data Acuan Area</span>
        </b-button>
      </div>
    </div>

    <!-- Table Section -->
    <div class="coverage-table-container">
      <b-overlay
        :show="loadingData"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        class="w-100"
        rounded="sm"
      >
        <b-table
          id="table"
          hover
          show-empty
          :items="listRequested"
          :fields="fields"
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          table-class="custom-coverage-table m-0"
        >
          <template #cell(created_at)="data">
            <span class="text-dark-gray">
              {{ DAY_MONTH_YEAR(data.item.created_at) }}
            </span>
          </template>
          <template #cell(city)="data">
            <span class="font-medium text-dark">
              {{ data.item.city || '-' }}
            </span>
          </template>
          <template #cell(note)="data">
            <span
              v-b-tooltip.hover
              :title="data.item.note"
              class="d-inline-block text-truncate text-dark-gray"
              style="max-width: 200px !important;"
            >
              {{ data.item.note || '-' }}
            </span>
          </template>
          <template #cell(uploaded_by)="data">
            <span class="text-dark-gray">
              {{ data.item.uploaded_by || '-' }}
            </span>
          </template>
          <template #cell(status)="data">
            <div class="d-flex justify-content-center">
              <span
                :class="statusBadgeClass(data.item.status)"
                class="label_status"
              >
                {{ classStatus(data.item.status) }}
              </span>
            </div>
          </template>
          <template #cell(coverage_excel_url)="data">
            <div class="d-flex justify-content-center align-items-center">
              <b-button
                class="p-0 border-0 bg-transparent btn-action-download"
                variant="plain"
                :disabled="data.item.status === 'on process'"
                @click="downloadExcel(data.value)"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/file-download.svg"
                  alt="download"
                  width="20"
                  height="20"
                >
              </b-button>
            </div>
          </template>
        </b-table>
      </b-overlay>
    </div>
  </b-card>
</template>

<script>
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { configFieldsRequested } from './config'

export default {
  data() {
    return {
      activeTab: 'komship',
      loadingData: true,
      listRequested: [],
      limit: 50,
      offset: 0,
      lastData: false,
      fields: configFieldsRequested,
      DAY_MONTH_YEAR,
    }
  },
  watch: {
    activeTab() {
      this.getlistRequested()
    },
  },
  created() {
    window.onscroll = () => {
      if ((window.innerHeight + window.scrollY) >= document.getElementById('table').offsetHeight && !this.loadingData) {
        this.getNextlistRequested()
      }
    }
  },
  mounted() {
    this.getlistRequested()
  },
  methods: {
    getlistRequested() {
      this.loadingData = true
      this.offset = 0
      const params = {
        limit: this.limit,
        offset: this.offset,
        source: this.activeTab,
      }
      this.$http_new.get('/komship/api/v1/admin/coverage-area/list', { params })
        .then(res => {
          const { data } = res.data
          this.listRequested = data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          this.offset = data.length
          this.loadingData = false
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(err => {
          this.loadingData = false
          if (this.offset === 0) {
            this.listRequested = []
          }
          this.$toast_error({ message: 'tidak mendapatkan list data' })
        })
    },
    getNextlistRequested() {
      if (!this.lastData) {
        this.loadingData = true
        const params = {
          limit: this.limit,
          offset: this.offset,
          source: this.activeTab,
        }
        this.$http_new.get('/komship/api/v1/admin/coverage-area/list', { params })
          .then(res => {
            const { data } = res.data
            this.listRequested.push(...data)
            this.listRequested.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            this.offset += data.length
            this.loadingData = false
            if (data.length < this.limit) {
              this.lastData = true
            } else {
              this.lastData = false
            }
          })
          .catch(err => {
            this.loadingData = false
            this.$toast_error({ message: 'tidak mendapatkan list data' })
          })
      }
    },
    statusBadgeClass(value) {
      const s = String(value || '').toLowerCase()
      if (s === 'completed' || s === 'berhasil' || s === 'success') return 'status-berhasil'
      if (s === 'failed' || s === 'gagal') return 'status-gagal'
      if (s === 'on process' || s === 'onprocess' || s === 'process') return 'status-onprogress'
      return 'status-default'
    },
    classStatus(value) {
      const s = String(value || '').toLowerCase()
      if (s === 'completed' || s === 'berhasil' || s === 'success') return 'Berhasil'
      if (s === 'failed' || s === 'gagal') return 'Gagal'
      if (s === 'on process' || s === 'onprocess' || s === 'process') return 'On Progress'
      return value || ''
    },
    downloadExcel(e) {
      window.open(e, '_parent')
    },
  },
}
</script>

<style lang="scss" scoped>
.coverage-area-page {
  border-radius: 8px;
  border: none;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.border-bottom-subtle {
  border-bottom: 1px solid #f1f1f4;
}

/* Tabs */
.tab-container {
  display: inline-flex;
  align-items: center;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 3px;
  gap: 3px;
}

.tab-btn {
  border: none;
  background: transparent;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:focus {
    outline: none;
  }

  &.active {
    background-color: #ffffff;
    color: #111827;
    font-weight: 600;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  &:hover:not(.active) {
    color: #111827;
  }
}

/* Action Buttons */
.btn-ubah-coverage {
  background-color: #ffffff !important;
  border: 1px solid #d1d5db !important;
  color: #374151 !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 8px 16px !important;
  box-shadow: none !important;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f9fafb !important;
    border-color: #9ca3af !important;
    color: #111827 !important;
  }
}

.btn-data-acuan {
  background-color: #f95031 !important;
  border: 1px solid #f95031 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 8px 16px !important;
  box-shadow: none !important;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e04020 !important;
    border-color: #e04020 !important;
    color: #ffffff !important;
  }
}

/* Table */
.coverage-table-container {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background-color: #ffffff;
}

::v-deep .custom-coverage-table {
  margin-bottom: 0 !important;

  thead th {
    background-color: #f9fafb !important;
    color: #374151 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    border-bottom: 1px solid #e5e7eb !important;
    border-top: none !important;
    padding: 13px 16px !important;
    white-space: nowrap;
    text-transform: inherit !important;
  }

  tbody tr {
    background-color: #ffffff;
    transition: background-color 0.15s ease;

    &:hover td {
      background-color: #fafbfc !important;
    }
  }

  tbody td {
    border-bottom: 1px solid #f3f4f6 !important;
    border-top: none !important;
    padding: 13px 16px !important;
    font-size: 13px !important;
    color: #374151;
    vertical-align: middle !important;
  }

  tbody tr:last-child td {
    border-bottom: none !important;
  }
}

.text-dark-gray {
  color: #374151;
}

/* Status Badges */
.label_status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  padding: 4px 14px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
  min-width: 80px;
  text-align: center;
}

.status-berhasil {
  background-color: #def7ec;
  color: #0e9f6e;
}

.status-gagal {
  background-color: #fee2e2;
  color: #ef4444;
}

.status-onprogress {
  background-color: #fef3c7;
  color: #d97706;
}

.status-default {
  background-color: #f3f4f6;
  color: #6b7280;
}

/* Action Icon */
.btn-action-download {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 4px !important;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    transform: scale(1.1);
    opacity: 0.85;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.35;
  }

  .action-icon {
    font-size: 20px;
    color: #f95031;
  }
}
</style>
